'use client';

import { createContext } from 'react';
//
import { WhopContextType } from '../../types';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as WhopContextType);
